
export const CONTRACT_TYPE_OPTIONS = [
  { value: "business-general", label: "一般合作 / 業務合作", prefix: "BIZ" },
  { value: "supply-purchase", label: "買賣 / 供貨合約", prefix: "SUP" },
  { value: "oem-manufacturing", label: "代工 / 製造委託 / OEM 合約", prefix: "OEM" },
  { value: "distribution-agency", label: "經銷 / 代理 / 通路合約", prefix: "DST" },
  { value: "service", label: "服務合約", prefix: "SVC" },
  { value: "mandate-consulting", label: "委任 / 顧問合約", prefix: "MDT" },
  { value: "kol-influencer", label: "廣告投放 / KOL 合作", prefix: "KOL" },
  { value: "marketing-cobrand", label: "聯名 / 聯合行銷", prefix: "MKT" },
  { value: "brand-ip-license", label: "授權 / 版權 / IP 使用", prefix: "IP" },
  { value: "lease", label: "租賃契約", prefix: "LSE" },
  { value: "employment-outsourcing", label: "聘僱 / 承攬", prefix: "HR" },
  { value: "software-saas", label: "軟體授權 / SaaS", prefix: "SaaS" },
  { value: "nda", label: "保密協議 (NDA)", prefix: "NDA" },
  { value: "other", label: "其他", prefix: "OTH" },
] as const;

export const getContractTypeLabel = (value: string) => {
  const found = CONTRACT_TYPE_OPTIONS.find(opt => opt.value === value);
  return found ? found.label : value;
};

export const getContractPrefix = (value: string) => {
  const found = CONTRACT_TYPE_OPTIONS.find(opt => opt.value === value);
  return found ? found.prefix : "OTH";
};
